// components/StateSelect.tsx
import React from "react";
import MasterDropdown from "../components/common/MasterDropdown";
import { useMasterDropdown } from "../hooks/useMasterDropdown";

interface StateSelectProps {
  value: string | number | null | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  label?: string;
  name?: string;
  disabled?: boolean;
}

const StateSelect: React.FC<StateSelectProps> = ({
  value,
  onChange,
  required = false,
  label = "State",
  name = "state",
  disabled = false,
}) => {
  const { options, loading } = useMasterDropdown({
    masterType: "states",
    enabled: true,
  });

  const handleChange = (newValue: string | number | null) => {
    // Mimic old event structure for backward compatibility
    const fakeEvent = {
      target: {
        name,
        value: newValue || "",
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(fakeEvent);
  };

  return (
    <MasterDropdown
      options={options}
      value={value}
      onChange={handleChange}
      loading={loading}
      label={label}
      name={name}
      required={required}
      disabled={disabled}
      fullWidth
      disableClearable={false}
    />
  );
};

export default StateSelect;
